"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreSonarObjectsOptimisticChangeAddSlice = void 0;
const name_1 = require("./name.js");
const xuder_1 = require("@sonar-software/xuder");
const state_1 = require("./state.js");
exports.coreSonarObjectsOptimisticChangeAddSlice = (0, xuder_1.createAddSyncSlice)({
    name: name_1.CoreSonarObjectsOptimisticChangeName,
    state: state_1.defaultSonarObjectsOptimisticChangeState,
    transform: (action) => (Object.assign(Object.assign({}, action), { sonarObjectIds: action.sonarObjectIds.reduce((ids, sonarObjectId) => (Object.assign(Object.assign({}, ids), { [sonarObjectId]: true })), {}) }))
});
//# sourceMappingURL=add.js.map